module.exports = __webpack_public_path__ + "static/img/aqyq.aca0828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/aqyq.png
// module id = d+2w
// module chunks = 1